import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isInventoryAccount, isStore } from '../Authetication'



export default function AccountRoutes() {


  let auth = {"token": isInventoryAccount()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
